import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {WhatsNewDisplayComponent} from "../whats-new-display/whats-new-display.component";
import {marker} from "@biesbjerg/ngx-translate-extract-marker";

@Component({
    selector: 'app-whats-new-indicator',
    styleUrls: ['./whats-new-indicator.component.scss'],
    templateUrl: './whats-new-indicator.component.html',
    standalone: false
})
export class WhatsNewIndicatorComponent {

  @Output() indicatorClosed = new EventEmitter();
  @Output() indicatorOpened = new EventEmitter();
  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    private matDialog: MatDialog,
  ) {
  }

  viewWhatsNew() {
    this.matDialog.open(WhatsNewDisplayComponent, {
      height: 'fit-content',
      width: '1000px',
      autoFocus: false,
      panelClass: 'dialog--no-padding',
    }).afterClosed().subscribe(() =>
    {
      this.indicatorOpened.emit();
    });
  }


  closeWhatsNew() {
    this.indicatorClosed.emit();
  }
}
